import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const ChlDialog = (p: any) => {
  const [openState, setOpenState] = useState(p.open);
  const { t } = useTranslation();

  useEffect(() => {
    setOpenState(p.open);
  }, [p.open]);

  function handleClose() {
    setOpenState(false);
  }

  return (
    <Dialog open={openState} onClose={handleClose}>
      <DialogContent>
        <DialogTitle className="dialogTitle"></DialogTitle>
        <div style={{textAlign: 'center'}} dangerouslySetInnerHTML={{ __html: t('summary.dialog.text') }} />
      </DialogContent>
    </Dialog>
  );
};
